import React from "react";
import classes from "./TermsPage.module.css";
import Layout from "../components/newComponents/Layout";
import Card from "../components/newComponents/Card";
import CardHeader from "../components/newComponents/CardHeader";
import List from "../components/newComponents/List";
import BottomNavbar from "../components/newComponents/BottomNavbar";

const TermsPage = () => {
  return (
    <Layout>
      <Card>
        <CardHeader title="How To Play?" />
        <List
          listItems={[
            "This is the demo instruction how to play!",
            "We are working on this game..",
            "Great you have learned how to play the game...",
          ]}
        />
        <div className={classes.divider}></div>
        <CardHeader title="Terms & Conditions" style={{padding:0}} />
        <List
          listItems={[
            "This is the demo terms & conditions!",
            "Will update this later accordingly..",
            "Great you have gone through the conditions..",
          ]}
        />
      </Card>
      <BottomNavbar active={3} />
    </Layout>
  );
};

export default TermsPage;
